import React from 'react'
import Grid from '@material-ui/core/Grid'
import Select from 'components/AddOrEditTaskPage/Select'
import TemplateName from 'components/TemplateForm/TemplateName'
import Subject from 'components/TemplateForm/Subject'
import language from 'utils/vast-languagepack'
import ActionTypePanel from 'components/AddOrEditTaskPage/ActionTypePanel'
import { connect } from 'react-redux'
import FromEmailSelect from 'components/AddOrEditTaskPage/FromEmailSelect'
import FromName from '../../../FromName'

const Form = ({
	warning,
	recipientSelectValueLength,
	templateNameValue,
	subjectValue,
}) => (
	<ActionTypePanel
		actionType="email"
		toolTip={language.task.add.toolTips.email}
		warning={
			warning
				? 'These are the email template details, and these fields are required.'
				: false
		}
	>
		<Grid container spacing={24}>
			<Grid item xs={12}>
				<Select warning={!recipientSelectValueLength} />
			</Grid>
			<Grid item xs={12}>
				<div style={{ position: 'relative' }}>
					<div
						style={{
							color: 'rgba(0, 0, 0, 0.54)',
							fontSize: ' 0.75rem',
							backgroundColor: '#fff',
							zIndex: 1,
							position: 'absolute',
							left: 40,
							top: -5,
							padding: '0 5px',
						}}
					>
						From:
					</div>
					<FromEmailSelect />
				</div>
			</Grid>
			<Grid item xs={12}>
				<FromName />
			</Grid>
			<Grid item xs={12}>
				<TemplateName
					warning={!templateNameValue}
					helperText={language.task.add.helperText.templateName}
				/>
			</Grid>
			<Grid item xs={12}>
				<Subject
					warning={!subjectValue}
					helperText={language.task.add.helperText.subject}
				/>
			</Grid>
		</Grid>
	</ActionTypePanel>
)

export default connect((state) => {
	const automationTypeSelected = state.tasks.addOrEdit?.automationTypeSelected
	const recipientSelectValueLength = state.tasks.addOrEdit.select?.value?.length
	const templateNameValue = state.email.templateName.value
	const subjectValue = state.email.subject.value

	const warning =
		automationTypeSelected === 'stage'
			? Boolean(!templateNameValue || !subjectValue)
			: Boolean(
					!recipientSelectValueLength || !templateNameValue || !subjectValue,
			  )

	return {
		warning,
		recipientSelectValueLength,
		templateNameValue,
		subjectValue,
	}
}, null)(Form)
